import React from 'react';

interface ErrorBoundaryState {
  hasError: boolean;
  message: string;
}

interface WidgetErrorBoundaryProps {
  name: string;
  children: React.ReactNode;
}

export class WidgetErrorBoundary extends React.Component<
  WidgetErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: WidgetErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return {
      hasError: true,
      message: error.message || 'Unexpected error.',
    };
  }

  componentDidCatch(error: Error) {
    // eslint-disable-next-line no-console
    console.error(`${this.props.name} widget render error:`, error);
  }

  render() {
    if (this.state.hasError) {
      const msg = this.state.message;
      let displayMessage = msg || `Unable to render ${this.props.name} widget.`;

      if (msg.includes('OrderTicketNavigationProvider')) {
        displayMessage =
          'OrderTicketNavigationContext is not available. Ensure this widget is rendered inside an OrderTicketNavigationProvider.';
      } else if (msg.includes('AuthProvider')) {
        displayMessage =
          'AuthContext is not available. Ensure this widget is rendered inside an AuthProvider.';
      }

      return (
        <div style={{ padding: '1rem', color: 'var(--color-error, #e74c3c)' }}>
          <strong>{this.props.name} unavailable</strong>
          <p style={{ marginTop: '0.5rem' }}>{displayMessage}</p>
        </div>
      );
    }
    return this.props.children;
  }
}
